import classnames from "classnames";
import { Button } from "neetoui";
import PropTypes from "prop-types";

import { RESPONSIVE_DEVICES_MAP } from "./constants";
import "./responsive-device-picker.scss";

const ResponsiveDevicePicker = ({
  className = "",
  selectedDevice,
  onDeviceChange,
  ...otherProps
}) => (
  <div
    className={classnames(
      "neeto-molecules-device-switcher flex items-center justify-center",
      className
    )}
    {...otherProps}
  >
    {Object.entries(RESPONSIVE_DEVICES_MAP).map(([key, { icon, label }]) => (
      <Button
        {...{ icon }}
        data-testid={`${label.toLowerCase()}-device-button`}
        key={key}
        size="small"
        style="tertiary"
        title={label}
        className={classnames("neeto-molecules-device-switcher__btn", {
          "neeto-molecules-device-switcher__btn--active":
            key === selectedDevice,
        })}
        onClick={() => onDeviceChange(key)}
      />
    ))}
  </div>
);

ResponsiveDevicePicker.propTypes = {
  /**
   * To specify external classnames as overrides.
   */
  className: PropTypes.string,
  /**
   * To show the active device.
   */
  selectedDevice: PropTypes.string,
  /**
   * Handler function that is triggered when one of the device options are selected.
   */
  onDeviceChange: PropTypes.func,
};

export default ResponsiveDevicePicker;
